<template>
  <div class="p-lg">
    <h2 class="m-b-lg">{{$t('configurator.chooseExtra', {tourName: orderTitle})}}</h2>
    <form>
      <div role="fieldset" class="flex space-between">
        <checkbox-card
          v-for="extra in extras"
          :key="extra.id"
          :id="extra.id"
          :value="extra.id"
          :checked="!!selectedExtras.includes(extra.id)"
          @change.native="selectExtra"
          :title="extra.Title"
          :price="getPrice(extra.Price, extra.PriceType)"
          :description="extra.Description"
          :iconURL="extra.Icon ? extra.Icon.url : iconFallback"
          class="m-b-lg card-extra"
        />
        <div v-if="extras.length % 3 !== 0" class="card-extra" />
      </div>
      <styled-button
        fullWidth
        type="button"
        @click="$emit('extras-selected', selectedExtras)"
      >{{$t('forms.next')}}</styled-button>
    </form>
  </div>
</template>
<script>
// getPrice()
import ConfiguratorMixin from '@/mixins/configurator';
import styledButton from '@/components/common/styledButton';
import checkboxCard from '@/components/checkboxCard.vue';
import iconFallback from '@/assets/images/fallback_icon.png';

export default {
	name: 'extra-selection',

	components: {
		styledButton,
		checkboxCard,
	},

	mixins: [ConfiguratorMixin],

	data() {
		return {
			iconFallback,
		};
	},

	props: {
		extras: {
			type: Array,
			required: true,
		},
		selectedExtras: {
			type: Array,
			required: true,
		},
		orderTitle: {
			type: String,
			required: true,
		},
	},

	mounted() {
		window.scroll(0, 0);
	},

	methods: {
		selectExtra(e) {
			const item = e.target.value;
			if (this.selectedExtras.includes(item)) {
				this.selectedExtras.splice(this.selectedExtras.indexOf(item), 1);
				return;
			}
			this.selectedExtras.push(item);
		},
	},
};
</script>
<style lang="scss" scoped>
.card-extra {
  width: 100%;
  @media screen and (min-width: 35rem) {
    width: 48%;
  }
  @media screen and (min-width: 73rem) {
    width: 100%;
    max-width: 23rem;
  }
}
</style>
